
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticClass:"toStroke",attrs:{"cx":"12","cy":"12.5","r":"11.136","stroke":"#121131","stroke-width":"1.728"}}),_c('path',{staticClass:"toStroke",attrs:{"d":"M4.8 21.137c1.374-2.57 3.84-4.797 7.2-4.797 3.36 0 5.826 2.228 7.2 4.797","stroke":"#121131","stroke-width":"1.728"}}),_c('circle',{staticClass:"toStroke",attrs:{"cx":"12","cy":"9.44","r":"4.236","stroke":"#121131","stroke-width":"1.728"}})])
          )
        }
      }
    